import { Component, ElementRef, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionCounterComponent } from '../../components/session-counter/session-counter.component';
import { AuthService } from '../../core/auth/auth.service';
import { API_CONSELHO_LOGO, API_CONSELHO_BOLA } from '../../app.constants';
import { LayoutService } from '../../shared/services/layout.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from '../../core/services/data.service';
import {  Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  standalone: true,
  imports: [SessionCounterComponent, CommonModule],
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild('topbarmenu') menu!: ElementRef;
  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  apiConselhoLogo = API_CONSELHO_LOGO;
  apiConselhoBola = API_CONSELHO_BOLA;
  
  private unsubscribe$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private dataService: DataService,
    private router: Router,
    public layoutService: LayoutService
  ) { }

  async logout() {
    // Não é mais necessário verificar isLoggingOut aqui, pois
    // o AuthService agora cuida disso internamente

  
    this.dataService.clearAllData();
    await this.authService.logout();
  }

  getUrlImagemLogo(): string {
    return this.apiConselhoLogo + this.authService.getUfUsuario() + '.png';
  }

  ngOnInit() {
    this.authService.isAuthenticated()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(isAuthenticated => {
        // Não chame logout aqui para evitar dupla chamada
        // O AuthService já cuidará do redirecionamento quando necessário
      });
  }

  getDescricaoConselho() {
    const uf = this.authService.getUfUsuario();
    return uf === 'br' ? 'Conselho Federal de Medicina' : 'Conselho Regional de Medicina - ' + uf.toUpperCase();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}